import type {
  Absence,
  AbsenceDraft,
  ReplacementDraft,
  ReplacementKind,
  ReplacementSlot,
  ReplacerEmployee,
} from "../types";

export const DEFAULT_BEGIN_TIME = "00:00";

export const DEFAULT_END_TIME = "23:59";

export function isNewAbsence(id: number): boolean {
  return id < 0;
}

export function draftFromAbsence(absence: Absence): AbsenceDraft {
  return {
    typeId: absence.typeId,
    sameCaseAbsenceId: absence.sameCaseAbsenceId,
    beginDate: absence.beginDate,
    endDate: absence.endDate,
    beginTime: absence.beginTime,
    endTime: absence.endTime,
    comment: absence.comment ?? "",
    replacements: {},
  };
}

export function slotDecision(
  slot: ReplacementSlot,
  draft: AbsenceDraft | null,
): ReplacementDraft {
  const pending = draft?.replacements[slot.replacedJobId];

  if (pending) {
    return pending;
  }

  return {
    kind: slot.kind,
    employeeId: slot.employeeId,
    employee: slotEmployee(slot),
    justification: slot.justification ?? "",
  };
}

function slotEmployee(slot: ReplacementSlot): ReplacerEmployee | null {
  return null === slot.employeeId
    ? null
    : {
        id: slot.employeeId,
        label: slot.employeeName ?? String(slot.employeeId),
        avatarUrl: slot.employeeAvatarUrl,
        hasPhoto: slot.employeeHasPhoto,
      };
}

export function isCovered(kind: ReplacementKind): boolean {
  return "none" !== kind;
}

export function coveredCount(
  slots: ReplacementSlot[],
  draft: AbsenceDraft | null,
): number {
  return slots.filter((slot) => isCovered(slotDecision(slot, draft).kind))
    .length;
}
